<div
  *ngIf="feedbackLoaded"
  class="selectiveProcessContainerPage"
  [ngClass]="{hasBackground: background}"
  [backgroundImage]="background">
  <div fxLayout="row wrap" fxLayoutAlign="center" fxFlex="100" style="margin-top: 20px;">
    <div fxLayoutAlign="center"  class="ps-form-container">
      <app-form-render style="flex:1 1 0%;" [defaultColor]="visualIdentity.institutional_color" [content]="feedback.content || []" [data]="feedback" [type]="2"></app-form-render>
    </div>
  </div>
</div>
